import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import _ from 'lodash';
// 销售的数据结构存在这种场景，部门A的负责人是P1,部门A下面的子部门B的负责人还是P1，这样后端会返回自己领导也是自己的数据结构，前端应该解析不了了.
// 如果这是一种合理的场景，解决方案后端可以不返回这种数据，或者看下前端的树能否兼容
function cleanPojos(pojos) {
    const result = [];
    pojos.forEach(pojo => {
        if (pojo.email === pojo.parent_email) {
            const hasSameEmail = pojos.find(el => el !== pojo && el.email === pojo.email);
            if (hasSameEmail) {
                // ignore this
            }
            else {
                const _pojo = { ...pojo };
                delete _pojo.parent_email;
                result.push(_pojo);
            }
        }
        else {
            result.push(pojo);
        }
    });
    return result;
}
/**
 * 数组转树  非递归求解
 * 利用数组和对象相互引用  时间复杂度O(n)
 * @param {Object} list
 */
const totree = (list) => {
    const nList = _.map(_.concat([], list), (el) => {
        const nEl = _.clone(el);
        nEl.id = el.email;
        el.parent_email && (nEl.pId = el.parent_email);
        nEl.label = el.name;
        return nEl;
    });
    const obj = {};
    const result = [];
    // 将数组中数据转为键值对结构 (这里的数组和obj会相互引用)
    nList.forEach(el => {
        obj[el.id] = el;
    });
    for (let i = 0, len = nList.length; i < len; i++) {
        const id = nList[i].pId;
        if (!id) {
            result.push(nList[i]);
            continue;
        }
        /** 容错处理，parent_id 不存在的数据，转化成一级数据 */
        if (!obj[id]) {
            // console.log(nList[i].email)
            result.push(nList[i]);
            continue;
        }
        if (obj[id].children) {
            obj[id].children.push(nList[i]);
        }
        else {
            obj[id].children = [nList[i]];
        }
    }
    return result;
};
let BehaviorService = class BehaviorService {
    constructor(i18n, behaviorApi) {
        this.i18n = i18n;
        this.behaviorApi = behaviorApi;
    }
    getSalesName(el) {
        return `${el.name || ''}${el.email || ''}${_.toString(el.mobileNumber) || ''}${el.id || ''}`;
    }
    getShowLabel(el) {
        return el.name || el.email || _.toString(el.mobileNumber) || el.id;
    }
    async getMixedEmailsTree({ salesFlag = true, csFlag = true, only_view = false }) {
        const params = {
            only_view,
            sales: salesFlag,
            am_ka: salesFlag,
            cs: csFlag,
        };
        const { sales_structure_pojos, other_pojos } = await this.behaviorApi.postDepartmentTreeByIds(params);
        let allData = [];
        let sales_structure_pojos_list = [];
        let other_pojos_list = [];
        if (!_.isEmpty(sales_structure_pojos)) {
            sales_structure_pojos_list = _.map(cleanPojos(sales_structure_pojos), (el) => {
                return {
                    ...el,
                    userName: el.name,
                    showLabel: this.getShowLabel(el),
                    name: this.getSalesName(el),
                };
            });
        }
        if (!_.isEmpty(other_pojos)) {
            const otherNode = {
                id: 'otherNode',
                name: this.i18n.t('achievement.pointsRecord.sources.OTHER'),
                email: 'otherNode',
                isDisabled: true,
                showLabel: this.i18n.t('achievement.pointsRecord.sources.OTHER'),
                userName: '',
            };
            other_pojos_list = _.concat(_.map(other_pojos, (el) => {
                return {
                    ...el,
                    userName: el.name,
                    showLabel: this.getShowLabel(el),
                    parent_email: 'otherNode',
                    name: this.getSalesName(el),
                };
            }), [otherNode]);
        }
        allData = _.concat(sales_structure_pojos_list, other_pojos_list);
        return {
            tree: totree(allData),
            list: allData,
        };
    }
    async getSalesList(csFlag = true, only_view) {
        const params = {
            only_view,
            sales: true,
            am_ka: true,
            cs: true,
        };
        if (!csFlag) {
            params.cs = false;
        }
        const { sales_structure_pojos, other_pojos } = await this.behaviorApi.postDepartmentTreeByIds(params);
        let allData = [];
        if (!_.isEmpty(sales_structure_pojos)) {
            allData = _.map(sales_structure_pojos, (el) => {
                return {
                    ...el,
                    showLabel: this.getShowLabel(el),
                    name: this.getSalesName(el),
                };
            });
        }
        if (!_.isEmpty(other_pojos)) {
            allData = _.concat(allData, _.map(other_pojos, (el) => {
                return {
                    ...el,
                    showLabel: this.getShowLabel(el),
                    name: this.getSalesName(el),
                };
            }));
        }
        return allData;
    }
    postCustomerLoginList(data) {
        return this.behaviorApi.postCustomerLoginList(data);
    }
    /** 获取看板踢人列表 */
    postPrivilegeConcurrencyList(params, data) {
        return this.behaviorApi.postPrivilegeConcurrencyList(params, data).then((data) => {
            const usedList = [];
            if (data && _.isArray(data)) {
                _.map(data, (el, index) => {
                    _.map(el.privilege_list, (privilege) => {
                        const item = {
                            company_id: el.company_id,
                            company_name: el.company_name,
                            kick_out_times: el.kick_out_times,
                            kick_out_user_times: el.kick_out_user_times,
                            package_name: privilege.package_name,
                            seat: privilege.seat,
                            concurrency: privilege.concurrency,
                            assign_seat: privilege.assign_seat,
                            arrived_concurrency: privilege.arrived_concurrency,
                            mergeRow: index,
                        };
                        usedList.push(item);
                    });
                });
            }
            return usedList;
        });
    }
};
BehaviorService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.BehaviorApi)),
    __metadata("design:paramtypes", [Object, Object])
], BehaviorService);
export { BehaviorService };
